import React from 'react'
import { Grid, Navbar } from '@softwaredev_cegeka/stix-core'
import { UnauthorizedCard } from 'src/components/UnauthorizedCard'
import logo from 'src/assets/images/catalog-logo.png'
import ContentTitle from 'src/components/ContentTitle'
import { reverse } from 'src/routes/config'
import 'src/assets/styles/error.scss'

export default function UnauthorizedPage() {
    // keep this outside of the main routes so we don't loop indefinitely
    // when the user is unauthorized
    return (
        <>
            <Navbar
                fixed={'top'}
                sticky={'top'}
                bg={'primary'}
                variant={'dark'}
            >
                <Navbar.Brand href={reverse('home')}>
                    <img src={logo} alt={'logo'} className={'logo'} />
                </Navbar.Brand>
            </Navbar>
            <Grid.Container className={'error-page'}>
                <ContentTitle>Unauthorized</ContentTitle>
                <UnauthorizedCard />
            </Grid.Container>
        </>
    )
}
